<div class="role-select-body">
  <button type="button" class="role-select-close" aria-label="Close" (click)="closeUsingCross()">&times;</button>

  <img class="role-select-logo" src="assets/SCRAII_LoginLogo.svg" alt="SCRAII" />
  <h2 class="role-select-title">Select Role</h2>

  <mat-form-field appearance="outline" class="matFformFieldRole">
    <mat-label>Role Name</mat-label>
    <mat-select [(ngModel)]="selectedRole" panelClass="role-select-panel">
      <mat-option *ngFor="let role of roles" [value]="role" title="{{ role.user_role_nm }}">{{ role.user_role_nm }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="role-select-actions">
    <button
      type="button"
      class="btn btn-primary btn-sm confirmBtnHomePopups"
      matTooltipClass="popup-confirm-tooltip"
      [disabled]="!selectedRole"
      (click)="selectRole(selectedRole)"
    >
      Confirm
    </button>
  </div>
</div>
